import {
    INSTAGRAM_UPDATE,
    INSTAGRAM_LIST,
    INSTAGRAM_CREATE
} from "../actions";

export function instagram(currentState = {}, action) {
    switch (action.type) {
        case INSTAGRAM_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case INSTAGRAM_LIST:
            return currentState = action
        case INSTAGRAM_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}